<template>
    <div v-if="message" :class="`notification-wrapper type-${type}`">
        <i :class="` icon icon-${getIcon()}`"></i>
        <div class="message">{{ message }}</div>
        <i class="icon icon-close-a" @click="clearTerminalNotification"></i>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TerminalNotification',
  computed: {
    ...mapGetters('notifications', ['terminalNotification']),
    message() {
      return this.terminalNotification && this.terminalNotification.message;
    },
    type() {
      return this.terminalNotification && this.terminalNotification.type;
    },
  },
  methods: {
    ...mapActions('notifications', ['clearTerminalNotification']),
    getIcon() {
      switch (this.type) {
        case 'success':
          return 'check-a';
        default:
          return 'info';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-wrapper {
  width: 520px;
  height: 58.5px;
  position: fixed;
  bottom: 20px;
  left: 20px;
  border-radius: 4px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  color: #ffffff;
  z-index: 999;

  &.type-info {
    background-color: #1565C1;
  }

  &.type-success {
    background-color: var(--system-positive);
  }

  &.type-warning {
    background-color: var(--system-negative);
  }


  .message {
    width: 100%;
    text-align: left;
    font-weight: 500;
  }

  @media (min-width: 1280px) {
    width: 640px;
    height: 72px;
  }
}
</style>
